import classNames from 'classnames'

import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'

import { sourceTypeLabels } from '../../lib/stockImportsLogLabels'
import {
  buildJournalConfigOption,
  getJournalConfigColumnWidths,
  matchesJournalConfigOption,
} from '../../lib/stockImportsSupplierScope'
import type { StockImportConfigShortModel } from '../../types/stockImports.types'
import cn from './JournalConfigFilter.module.scss'

interface JournalConfigFilterProps {
  configs: StockImportConfigShortModel[]
  value: string | undefined
  withSupplier: boolean
  isOrganisationSelected: boolean
  onChange: (configId: string | undefined) => void
}

function JournalConfigFilter({
  configs,
  value,
  withSupplier,
  isOrganisationSelected,
  onChange,
}: JournalConfigFilterProps) {
  const options = configs.map((config) =>
    buildJournalConfigOption(
      config,
      sourceTypeLabels[config.sourceType],
      withSupplier
    )
  )
  const rowClassName = classNames(cn.row, withSupplier && cn.rowWithSupplier)
  const widths = getJournalConfigColumnWidths(options)
  const columnsStyle = {
    '--journal-supplier-width': `${widths.supplier}ch`,
    '--journal-store-width': `${widths.store}ch`,
    '--journal-source-width': `${widths.sourceType}ch`,
  }

  const optionsById = new Map(options.map((option) => [option.value, option]))
  const findOption = (optionValue: unknown) =>
    optionsById.get(String(optionValue))

  return (
    <HoverElement>
      <AtomSelect
        openByHover={false}
        outlined
        showSearch
        allowClear
        placeholder="Настройка"
        value={value}
        options={options}
        isOrganisationSelected={isOrganisationSelected}
        popupMatchSelectWidth={false}
        handleChange={(configId) => {
          if (typeof configId === 'string') onChange(configId)
        }}
        handleClear={() => onChange(undefined)}
        filterOption={(search, option) => {
          const journalOption = findOption(option?.value)
          return journalOption
            ? matchesJournalConfigOption(search, journalOption)
            : false
        }}
        labelRender={({ label }) => <span title={String(label)}>{label}</span>}
        optionRender={({ data }) => {
          const journalOption = findOption(data.value)
          if (!journalOption) return null
          return (
            <div className={rowClassName}>
              {withSupplier && <span>{journalOption.supplier}</span>}
              <span>{journalOption.store}</span>
              <span>{journalOption.sourceType}</span>
            </div>
          )
        }}
        popupRender={(menu) => (
          <div style={columnsStyle}>
            <div className={classNames(rowClassName, cn.header)}>
              {withSupplier && <span>Поставщик</span>}
              <span>Склад</span>
              <span>Тип загрузки</span>
            </div>
            {menu}
          </div>
        )}
      />
    </HoverElement>
  )
}

export default JournalConfigFilter
